module.exports = __webpack_public_path__ + "static/media/pic9.2ba6b079.jpg";